import { createAction } from '@reduxjs/toolkit'

export const HIDE_NOTIFICATION = '@pwa/HIDE_NOTIFICATION'

// ------

export const hideNotification = createAction(HIDE_NOTIFICATION)
